/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchUserBadge,
  KillswitchUserBadge$inboundSchema,
} from "./killswitchuserbadge.js";

export type KillswitchBatchUserBadgesResult = {
  badges: Array<KillswitchUserBadge>;
};

/** @internal */
export const KillswitchBatchUserBadgesResult$inboundSchema: z.ZodMiniType<
  KillswitchBatchUserBadgesResult,
  unknown
> = z.object({
  badges: z.array(KillswitchUserBadge$inboundSchema),
});

export function killswitchBatchUserBadgesResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchBatchUserBadgesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchBatchUserBadgesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchBatchUserBadgesResult' from JSON`,
  );
}
